import { Layer, Source } from 'react-map-gl/dist/es5'
import { useInventoryFeatures } from '../../../../features/Inventories/queries/useInventoryFeatures'
import { useBoundaryStyles } from '../../../../features/Inventories/useBoundaryStyles'

interface InventoryGeometryLayersProps {
  inventoryId: string
}

export const InventoryGeometryLayers = ({ inventoryId }: InventoryGeometryLayersProps) => {
  const boundaryStyles = useBoundaryStyles()
  const inventoryFeatures = useInventoryFeatures(inventoryId)

  if (!inventoryFeatures.data) return null

  return (
    <Source type="geojson" data={inventoryFeatures.data}>
      <Layer id={`inventory-area-fill`} type="fill" paint={boundaryStyles.fill} />
      {/* @ts-ignore the style works */}
      <Layer id={`inventory-area-stroke`} type="line" paint={boundaryStyles.paint} />
    </Source>
  )
}
